import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnrealengineComponent } from './simple-icons-unrealengine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnrealengineComponent ],
    exports:      [ SimpleIconsUnrealengineComponent ],
    bootstrap:    []
})
export class SimpleIconsUnrealengineModule {}
